import React, { Component } from 'react';
import styled from "styled-components";
import backup from './error.jpg';
import { TwitterShareButton } from 'react-twitter-embed';


const StyledNoms = styled.section`
  background-color: var(--yellow);
  padding-top: 15vh;
  padding-bottom: 15vh;

  .twitterDiv{
    filter: grayscale(1);
    text-align: center;
    margin-top: 5vh;
  }

  .twitterDivN{
    filter: grayscale(1);
    margin-top: 5vh;
  }
`

const StyledNom = styled.li`
  background-color: var(--yellow);
  border: 2px solid var(--black);
  margin: 10px auto;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 60%;
  min-width: 300px;

  img{
    height: 150px;
    margin-right: 20px;
    border-bottom: 2px solid var(--black);
  }

  p{
    font-size: 20px;
  }
  
  div{
    display: flex;
    align-items: center;
  }

  button{
    background: none;
    line-height: 1.15;
    margin-right: 10px;
  }

  @media(max-width:600px){
    width: 100%;

    p{
      font-size: 16px;
    }
  }
`


class Nominees extends Component {


  render(){
    if(this.props.noms === null || this.props.noms.length === 0){
      return(
        <StyledNoms className="nominees" id="nominees">
        <div className="wrapper">
          <h2>Nominees</h2>
          <p>Nominate some films!</p>
            <div className="twitterDivN" id="twitterDiv">
              <TwitterShareButton
                key={this.props.noms}
                options={{
                  text: "I'm picking my nominees for the 2021 Shoppies! Pick your five movies now! #shoppies", size: 'large'
                }}
              />
            </div>
        </div>
        </StyledNoms>
      )
    }else{

    const fire = this.props.noms[0].Title;
    return(

      <StyledNoms className="nominees" id="nominees">
      <div className="wrapper">
        <h2>Nominees</h2>
        <ul>
        {this.props.noms.map(nom=>{
          return <StyledNom className="film" key={'n' + nom.Title}>
            <div>
            <img src={nom.Poster !== 'N/A' ? nom.Poster : backup} alt={"movie poster of" + nom.Title} name={nom.imdbID} tabIndex="0"/>
            <p className="itemInfo">{nom.Title} ({nom.Year})</p>
            </div>
            <button value={nom.imdbID} onClick={this.props.removeNom}>Delete</button>
            </StyledNom>
        })}
        </ul>
        <div className="twitterDiv" id="twitterDiv">
          <TwitterShareButton
            key={this.props.noms}
            options={{
              text: "I nominated " + fire + ' and more for the 2021 Shoppies! Pick your five nominees now! #shoppies', size: 'large'
                }}
          />
        </div>
      </div>
      </StyledNoms>
    )
    }
  }
}

export default Nominees;